import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import EdSwitch from '@/components/forms/EdSwitch'

interface MixedAttoriDidatticiSectionProps {
  isReadOnly?: boolean;
}

const MixedAttoriDidatticiSection = ({ isReadOnly = false }: MixedAttoriDidatticiSectionProps) => {
  const { register, watch, setValue } = useFormContext();

  const selections = watch('attoriSelezionati') || {};
  const tipoSelezione = watch('tipoSelezioneAttori') || 'enti';

  const items = [
    { id: '1', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '2', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '3', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '4', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '5', name: 'Carlo Trainao', role: 'Tutor di processo' },
  ];

  // Imposta i primi due selezionati al primo render se non presente nel form
  useEffect(() => {
    if (!selections || Object.keys(selections).length === 0) {
      setValue('attoriSelezionati', { '1': true, '2': true }, { shouldDirty: false });
    }
    // Imposta il valore di default per il tipo di selezione (enti è pre-selezionato)
    if (true) {
      setValue('tipoSelezioneAttori', 'enti', { shouldDirty: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <span className="text-[20px] text-[#4F4F4F] font-bold">Selezione Attori didattici</span>

      {/* Radio buttons per tipo selezione */}
      <div className="flex gap-6">
        <label className={`flex items-center gap-2 ${isReadOnly ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
          <input
            type="radio"
            value="enti"
            {...register('tipoSelezioneAttori')}
            disabled={isReadOnly}
            className={`w-4 h-4 text-[#B80F15] border-gray-300 focus:ring-[#B80F15] ${isReadOnly ? 'cursor-not-allowed ' : ''}`}
          />
          <span className="text-sm text-[#4F4F4F]">Enti</span>
        </label>
        <label className={`flex items-center gap-2 ${isReadOnly ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}>
          <input
            type="radio"
            value="soggetto_attuatore"
            {...register('tipoSelezioneAttori')}
            disabled={isReadOnly}
            className={`w-4 h-4 text-[#B80F15] border-gray-300 focus:ring-[#B80F15] ${isReadOnly ? 'cursor-not-allowed opacity-50' : ''}`}
          />
          <span className="text-sm text-[#4F4F4F]">Soggetto attuatore</span>
        </label>
      </div>

      <div className="flex flex-row gap-2 w-full bg-[#B80F151A] p-3 box-border items-center justify-start rounded-[8px]"><i className="ri-lightbulb-line text-[#B80F15] text-[20px]"></i><span className="text-sm text-[#B80F15] font-bold">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</span></div>

      {/* Lista attori con switch */}
      <div className="w-full ">
        {items.map((item, idx) => {
          const checked = !!selections?.[item.id];
          const isPrincipale = (item.id === '1' || item.id === '2') && tipoSelezione === 'enti';
          return (
            <div key={item.id} className={`flex items-center justify-between px-0 py-1.5 ${idx !== items.length - 1 ? 'border-b border-gray-200' : ''}`}>
              <div className="flex items-center gap-12">
                <div className="flex items-center gap-3 min-w-[180px]">
                  <span className="text-sm text-black">{item.name}</span>
                </div>
                <span className="text-sm text-[#6B7280]">{item.role}</span>
                  {isPrincipale && (
                    <span className="text-xs font-semibold text-white bg-[#B80F15] px-2 py-0.5 rounded">Principale</span>
                  )}
              </div>
              
              <div className="flex items-center gap-0">
              <EdSwitch
                  id={`attore-${item.id}`}
                  value={checked}
                  onChange={() => setValue(`attoriSelezionati.${item.id}`, !checked, { shouldDirty: true })}
                  disabled={isReadOnly}
                />
                <span className={`text-sm mr-10 ${checked ? 'text-black' : 'text-gray-400'}`}>Selezionato Fad</span>
                <EdSwitch
                  id={`attore-${item.id}`}
                  value={checked}
                  onChange={() => setValue(`attoriSelezionati.${item.id}`, !checked, { shouldDirty: true })}
                  disabled={isReadOnly}
                />
                <span className={`text-sm ${checked ? 'text-black' : 'text-gray-400'}`}>Selezionato Aula</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  )
}

export default MixedAttoriDidatticiSection